<div
    id="sensitive-content-container"
    *ngIf="display"
    [ngClass]="{ customClasses, 'pt-md-7': !isLBPage }"
    class="d-flex flex-column position-relative justify-content-sm-center justify-content-md-start align-items-center gtmsection-caution-flags-box"
    [class]="resource?.mediaType === 'Audio' ? 'pt-4 pt-xs-2' : 'pt-xs-0'"
>
    <div
        class="sensitive-content-body d-flex flex-column align-items-center justify-content-xs-center justify-md-content-start"
    >
        <button
            type="button"
            class="btn-close pt-xl-2"
            data-dismiss="modal"
            aria-label="Close"
            (click)="closeContainer()"
        ></button>
        <div class="header mt-xs-3 d-flex flex-row justify-content-center">
            <div
                class="exclamation-container d-flex flex-row justify-content-center align-items-center"
            >
                <app-icon type="Exclamation-Circle" class="exclamation"> </app-icon>
            </div>
        </div>
        <div class="body text-center">
            <h3 class="mt-4">This media contains sensitive content.</h3>
            <h4 class="mt-3" *ngIf="innerWidth >= 576 && !isLBPage">
                Please review the Cautions tab below.
            </h4>
            <div
                class="action-buttons mt-4 text-center w-100 d-flex flex-row justify-content-center"
            >
                <button
                    class="btn btn-outline-secondary mx-md-5 mx-xs-3 px-md-5 px-xs-2 py-md-2 gtm-view-cautions-button d-flex flex-row align-items-center"
                    (click)="toggleCautionTab()"
                >
                    View Cautions
                    <app-icon *ngIf="isLBPage" type="External-link" class="link-icon ms-2">
                    </app-icon>
                </button>
                <button
                    [ngClass]="customActionGTMClassName"
                    class="btn btn-primary mx-md-5 mx-xs-3 px-md-5 px-xs-3 py-md-2 d-flex align-items-center"
                    (click)="closeContainer(true)"
                >
                    <app-icon *ngIf="isVideo" type="Video" class="video-icon"> </app-icon>
                    {{ actionButtonName }}
                    <app-icon
                        *ngIf="resourceOpensInNewTab"
                        type="Expand"
                        class="expand-link-icon ms-2"
                    >
                    </app-icon>
                </button>
            </div>
        </div>
        <div class="footer mt-4 pb-xs-4 pb-md-4">
            <button
                (click)="dismissCautionContainer()"
                class="dismiss-button gtm-dismiss-cautions-button"
            >
                {{
                    innerWidth < 576 || isLBPage
                        ? "Dismiss and don't show again"
                        : "Dismiss caution and don't show again for this "
                }}
                <span *ngIf="innerWidth >= 576 && !isLBPage"
                    >{{ selectedAsset?.mediaType || resourceMediaType | lowercase }}
                </span>
            </button>
        </div>
    </div>
</div>
